import _ from "lodash";
import * as DateUtils from "../../../utils/date/date";
import { DateHelper } from "../DateHelper/DateHelper";

export class AvailablePeriod {
    constructor({ Available } = {}) {
        this.Available = Available;
    }

    /**
     * @public
     * Retorna datas dos points
     * @param {Array} points
     */
    getByPoints(points) {
        const result = points
            .map((item) => item.t)
            .filter((value, index, self) => self.indexOf(value) === index);
        return result;
    }

    /**
     *
     * @param {Object} param0
     * @returns
     */
    getDates({ companyId, source, scenarioId, period, dateReference }) {
        const available = this.Available.findOneCollection({
            companyId: companyId
        });

        if (!available) return false;

        const dates = _.get(available, `date.${scenarioId}.${source}`);

        const availableDatesFormat = dates.map((date) =>
            DateUtils.getDate(new Date(date).toISOString())
        );

        const response = this._getDatesFormat({
            available: availableDatesFormat,
            period,
            dateReference
        });

        return response.sort((a, b) => new Date(a) - new Date(b));
    }

    /**
     * @private
     * Seta as datas disponiveis
     */
    _getDatesFormat({ available, period, dateReference }) {
        let dateInterval = [];

        if (!available) return;

        available.forEach((date, i, array) => {
            if (+dateReference == +date)
                dateInterval = array.filter((d, j) => j <= i);
        });

        const multiplier = {
            monthly: 1,
            quarterly: 3,
            semester: 6,
            yearly: 12
        };

        let dates = _.takeRight(dateInterval, multiplier[period] * 12);

        if (period == "yearly") {
            dates = this._getYears(dateReference);
        }

        if (period == "quarterly") {
            dates = dates.filter((date, index) => {
                const month = Number(
                    new DateHelper(date).startOf("month").format("M")
                );

                if ([3, 6, 9, 12].includes(month)) return date;
            });
        }

        if (period == "semester") {
            dates = dates.filter((date, index) => {
                const month = Number(
                    new DateHelper(date).startOf("month").format("M")
                );

                if ([6, 12].includes(month)) return date;
            });
        }

        return dates;
    }

    /**
     * Method that gets the available dates based on the period
     */
    _getYears(dateReference) {
        const dates = [];
        const year = new Date(moment(dateReference)).getFullYear();
        dates.forEach((d) => {
            const date = moment(d);
            if (date.month() == 10 && date.year() <= year) dates.push(d);
        });
        return dates;
    }

    /**
     * @public
     * Get the object of period labels
     * @returns {Object} Labels by quarters number
     */
    quarters() {
        return {
            2: "1º Trimestre",
            5: "2º Trimestre",
            8: "3º Trimestre",
            11: "4º Trimestre"
        };
    }

    semesters() {
        return {
            5: "1º Semestre",
            11: "2º Semestre"
        };
    }

    /**
     * @private
     * Retona o nome de um Quarterly de acordo com uma data
     * @param {Object} moment
     * @param {Boolean}
     *
     * @returns {String}
     */
    nameQuarterly = (date, abrev = false) => {
        const quarterly = moment(date).add(1, "month").month();

        const quarterlys = DateUtils.quarters();

        const result = quarterlys[quarterly];
        if (abrev && result) return result.substring(0, 4);

        return result;
    };

    /**
     * @private
     * Retona o nome de um semestre de acordo com uma data
     * @param {Object} moment
     * @param {Boolean}
     *
     * @returns {String}
     */
    nameSemester = (date, abrev = false) => {
        const semester = moment(date).add(1, "month").month();

        const semesters = DateUtils.semesters();

        const result = semesters[semester];
        if (abrev && result) return result.substring(0, 4);

        return result;
    };

    /**
     * @public
     * Retorna a label do period
     * @param {String} date
     * @param {String} period
     * @returns
     */
    getPeriodLabels(date, period) {
        const year = DateUtils.dateToString(date, "yyyy");

        if (period == "quarterly") {
            const response = `${DateUtils.nameQuarterly(date, true)} ${year}`;

            return response;
        }

        if (period == "semester") {
            const response = `${DateUtils.nameSemester(date, true)} ${year}`;

            return response;
        }

        return year;
    }

    getYears(available = []) {
        let years = [];

        for (let index = 0; index < available.length; index++) {
            const year = DateUtils.getFullYear(available[index]);

            years.push(year);
        }

        return _.uniq(years);
    }

    yearIsAvailable({ available = [], year, period }) {
        if (!available.length) return false;

        if (period === "yearly") {
            const dates = available.filter(
                (date) => DateUtils.getFullYear(date) === year
            );
            if (dates.length === 12) return true;
            else return false;
        }

        const years = this.getYears(available);
        if (years.indexOf(year) > -1) return true;
    }

    dateIsAvailable({ available = [], year, month, period }) {
        if (!available.length) return false;

        const monthRegular = month < 10 ? `0${month}` : `${month}`;

        const date = new Date(`${year}-${monthRegular}`);

        const periods = {
            monthly: () => {
                return available.find((dt) => {
                    const _dt = new Date(dt);
                    return (
                        `${_dt.getUTCFullYear()}-${_dt.getUTCMonth()}` ===
                        `${date.getUTCFullYear()}-${date.getUTCMonth()}`
                    );
                });
            },
            quarterly: () => {
                const months = [0, -1, -2];
                const dates = [];

                months.forEach((m) => {
                    const regularMonth = DateUtils.getRegularMonth(date);
                    const dtSub = DateUtils.addToDate(
                        `${date.getUTCFullYear()}-${regularMonth}-01`,
                        m,
                        "months"
                    );
                    const dt = available.find((dt) => {
                        const _dt = new Date(dt);

                        return (
                            `${_dt.getUTCFullYear()}-${_dt.getUTCMonth()}` ===
                            `${dtSub.getUTCFullYear()}-${dtSub.getUTCMonth()}`
                        );
                    });

                    if (dt) dates.push(dt);
                });
                if (dates.length === months.length) return true;
            },
            semester: () => {
                const months = [0, 1, 2, 3, 4, 5];
                const dates = [];

                months.forEach((m) => {
                    const regularMonth = DateUtils.getRegularMonth(date);
                    const dtSub = DateUtils.getPreviousMonth(
                        `${date.getUTCFullYear()}-${regularMonth}-01`,
                        m
                    );

                    const dt = available.find((dt) => {
                        const _dt = new Date(dt);

                        return (
                            `${_dt.getUTCFullYear()}-${_dt.getUTCMonth()}` ===
                            `${dtSub.getUTCFullYear()}-${dtSub.getUTCMonth()}`
                        );
                    });

                    if (dt) dates.push(dt);
                });
                if (dates.length === months.length) return true;
            }
        };

        return periods[period] ? periods[period]() : true;
    }

    getMonths(companyId, year, source, scenarioId) {
        return this.Available.getMonths(
            companyId,
            year,
            source,
            scenarioId
        ).map((value, index) => ({
            ...value,
            value: index
        }));
    }

    getQuarters(companyId, year, source, scenarioId) {
        const quarters = DateUtils.quarters();
        const months = this.getMonths(companyId, year, source, scenarioId);
        return Object.values(quarters).map((nameQuarter, index) => {
            const foundMonth = months.find(
                (m) => m.value === Number(Object.keys(quarters)[index])
            );

            return {
                ...foundMonth,
                month: nameQuarter
            };
        });
    }

    getQuartersAvailable({ companyId, source, scenarioId, options = {} }) {
        const quarters = DateUtils.quarters();
        const quartersMonths = Object.keys(quarters);
        const available = this.Available.get({
            companyId,
            scenarioId,
            source,
            options
        });
        return available.filter((date) => {
            const month = new Date(date).getUTCMonth();
            return quartersMonths.includes(String(month));
        });
    }

    getSemestersAvailable({ companyId, source, scenarioId, options = {} }) {
        const semesters = DateUtils.semesters();
        const semestersMonths = Object.keys(semesters);
        const available = this.Available.get({
            companyId,
            scenarioId,
            source,
            options
        });
        return available.filter((date) => {
            const month = new Date(date).getUTCMonth();
            return semestersMonths.includes(String(month));
        });
    }

    getSemesters(companyId, year, source) {
        const semesters = DateUtils.semesters();
        const months = this.getMonths(companyId, year, source);
        return Object.values(semesters).map((nameSemester, index) => {
            const foundMonth = months.find(
                (m) => m.value === Number(Object.keys(semesters)[index])
            );
            return {
                ...foundMonth,
                month: nameSemester
            };
        });
    }

    getDateAvailable(companyId, availables, date) {
        let availableYear = availables[0];
        const year = date.split("-")[0];
        const lastMonth =
            this.Available.getLastMonth(companyId, Number(year)) || 1;

        const isDateAvailable = availables.includes(parseInt(year));

        if (isDateAvailable || year == "todos") availableYear = year;
        else availableYear = availables[0] || new Date().getFullYear();

        return new Date(`${year}-0${parseInt(lastMonth) + 1}-01`);
    }

    availableMonth(
        companyId,
        year,
        source,
        month,
        comparationView,
        scenarioId
    ) {
        const periods = {
            monthly: (args) => this.getMonths(...args),
            quarterly: (args) => this.getQuarters(...args),
            semester: (args) => this.getQuarters(...args)
        };

        if (!periods[comparationView]) return;
        const months = periods[comparationView]([
            companyId,
            year,
            source,
            scenarioId
        ]);
        return months.find((m) => m.value + 1 === Number(month)) || months[0];
    }

    /**
     * @private
     * @param {string} nameMonth - Nome do tipo de período
     * Retorna valores com cada ano com o seu ultimo período disponível
     * @return {Array<object>} - retorna dos valores em um array tendo eles ano base e o ano para comparar
     */
    availableDates(namePeriod, companyId, source) {
        if (namePeriod === "yearly")
            return this.availableYears(companyId, source);

        const _available = this.Available.get({
            companyId,
            scenarioId: "ORIGINAL",
            source: source
        });

        const available = _available
            .map((date) => {
                if (date.toISOString) return date;

                return new Date(date.replace("-", "/").split("T")[0]);
            })
            .sort((a, b) => b - a);

        const periods = {
            monthly: 1,
            quarterly: 3,
            semester: 6
        };

        const valuePerios = {
            monthly: (dateAvailable) => ({
                available: true,
                date: dateAvailable,
                monthNumber: dateAvailable.getUTCDate(),
                month: DateUtils.months(dateAvailable.getUTCMonth()),
                value: dateAvailable.getUTCMonth()
            }),
            quarterly: (dateAvailable) => ({
                available: true,
                date: dateAvailable,
                monthNumber: regularMonth(dateAvailable.getUTCMonth()),
                month: DateUtils.nameQuarterly(dateAvailable, false),
                value: dateAvailable.getUTCMonth()
            }),
            semester: (dateAvailable) => ({
                available: true,
                date: dateAvailable,
                monthNumber: regularMonth(dateAvailable.getUTCMonth()),
                month: DateUtils.nameSemester(dateAvailable, false),
                value: dateAvailable.getUTCMonth()
            })
        };

        const regularMonth = (month) => {
            return String(month).padStart(2, "0");
        };

        const availablePeriods = [];
        for (let i = 11; i >= 0; i = i - periods[namePeriod]) {
            const getAvailable = available.find((av) => av.getUTCMonth() === i);

            if (getAvailable) {
                availablePeriods.push({
                    date: getAvailable,
                    year: getAvailable.getUTCFullYear(),
                    period: !valuePerios[namePeriod]
                        ? valuePerios["monthly"](getAvailable)
                        : valuePerios[namePeriod](getAvailable)
                });
            }
        }

        return availablePeriods.sort((a, b) => b.date - a.date);
    }

    availableYears(companyId, source) {
        const years = this.Available.getYears(companyId, source)
            .sort()
            .reverse();
        return years.map((year) => ({
            year,
            date: new Date(`${year}/12/01`),
            period: null
        }));
    }

    sliceYearsByDateFrom({ years, dateFrom }) {
        if (!years || !dateFrom) return [];

        const sortedYears = years.sort();

        const groupStartYear = DateUtils.getFullYear(dateFrom);

        const yearIndex = sortedYears.indexOf(groupStartYear);

        return sortedYears.slice(yearIndex);
    }

    getMonthComparation({
        periodDate,
        comparationDate,
        availablePeriod,
        availableComparation
    }) {
        const periodDates = availablePeriod.filter((date) => {
            const dateYear = new Date(date).getUTCFullYear();

            const periodDateYear = periodDate.getUTCFullYear();

            return dateYear == periodDateYear;
        });

        const comparationDates = availableComparation.filter((date) => {
            const dateYear = new Date(date).getUTCFullYear();

            const periodDateYear = comparationDate.getUTCFullYear();

            return dateYear == periodDateYear;
        });

        if (periodDates.length == 12 || comparationDates.length == 12)
            return 12;

        const lastPeriodDate = _.last(periodDates);
        const lastPeriodMonth = new Date(lastPeriodDate).getUTCMonth();
        const lastComparationDate = _.last(comparationDates);
        const lastComparationMonth = new Date(
            lastComparationDate
        ).getUTCMonth();

        const max = Math.max(lastPeriodMonth, lastComparationMonth);

        const regularMonth = String(max + 1).padStart(2, "0");

        return regularMonth;
    }

    getDatesBySourceESocial({
        periodDate,
        comparationDate,
        source,
        availablePeriod,
        period
    }) {
        if (source != "eSocial") return { periodDate, comparationDate };

        if (availablePeriod.length < 3) return { periodDate, comparationDate };

        const index = availablePeriod.findIndex((date) => {
            const dt = new Date(date);
            const dtNumber = Number(
                `${dt.getUTCFullYear()}${dt.getUTCMonth()}`
            );

            const periodDateNumber = Number(
                `${periodDate.getUTCFullYear()}${periodDate.getUTCMonth()}`
            );

            return dtNumber === periodDateNumber;
        });

        if (index + 1 === availablePeriod.length) {
            const multiplier = {
                monthly: 1,
                quarterly: 3,
                semester: 6,
                yearly: 12
            };

            const previousPeriodDate = DateUtils.getPreviousMonth(
                periodDate,
                multiplier[period]
            );

            const previousComparationDate = DateUtils.getPreviousMonth(
                previousPeriodDate,
                multiplier[period]
            );

            return {
                periodDate: previousPeriodDate,
                comparationDate: previousComparationDate
            };
        }

        return { periodDate, comparationDate };
    }

    getLastPeriodByAnalysisPlus({
        companyId,
        source,
        scenarioId,
        projection,
        budget,
        period
    }) {
        let availables = [];
        const periods = {
            monthly: () => {
                return this.Available.get({
                    companyId,
                    scenarioId,
                    source,
                    options: {
                        projection,
                        separatted: true,
                        budget
                    }
                });
            },
            quarterly: () => {
                return this.getQuartersAvailable({
                    companyId,
                    source,
                    scenarioId,
                    options: {
                        projection,
                        budget
                    }
                });
            },
            semester: () => {
                return this.getSemestersAvailable({
                    companyId,
                    source,
                    scenarioId,
                    options: {
                        projection,
                        budget
                    }
                });
            },
            yearly: () => {
                return this.Available.get({
                    companyId,
                    scenarioId,
                    source,
                    options: {
                        projection,
                        budget
                    }
                });
            }
        };
        availables = periods[period]();
        if (projection === "PROGRESSAO_LINEAR") {
            if (["quarterly", "semester"].includes(period))
                return _.last(availables);
            else
                return (
                    availables.projectionDates[5] || _.last(availables.allDates)
                );
        }
        if (["quarterly", "semester"].includes(period))
            return _.last(availables);
        return _.last(availables.allDates);
    }

    getStartDate({ available, monthsPrevs = -13 }) {
        const ultimasDozePosicoes = available.slice(monthsPrevs);
        return ultimasDozePosicoes[0];
    }

    /**
     * @public
     * Fecha cada periodo pelo seu ultimo mes -- trimestre em mar/jun/set/dez, semestre em
     * jun/dez, ano em dez -- mesmo quando o periodo ainda esta em curso e esse mes nao existe
     * entre as datas disponiveis.
     *
     * `filterDatesByPeriod` so devolve o mes de fechamento que ja esta na lista, entao um ano
     * com dado ate setembro sumia da tabela, embora a calculatrix devolva o ponto anual
     * carimbado em dezembro e os graficos ao lado ja mostrassem o valor parcial.
     *
     * Em `monthly` (ou periodo desconhecido) nao ha o que fechar: devolve as datas como estao.
     * @param {Object} param0
     * @param {Array<String|Date>} param0.dates
     * @param {"monthly"|"quarterly"|"semester"|"yearly"} param0.period
     * @returns {Array<String>} Datas de fechamento em ISO, unicas e ordenadas
     */
    getClosingDatesByPeriod({ dates, period } = {}) {
        const closingMonths = {
            quarterly: [3, 6, 9, 12],
            semester: [6, 12],
            yearly: [12]
        };
        const months = closingMonths[period];
        if (!months) return [...(dates || [])];
        const closings = (dates || []).map((date) => {
            const _date = new Date(date);
            const closingMonth = months.find(
                (month) => _date.getUTCMonth() + 1 <= month
            );
            return new Date(
                Date.UTC(_date.getUTCFullYear(), closingMonth - 1, 1)
            ).toISOString();
        });
        return _.uniq(closings).sort();
    }

    filterDatesByPeriod({ dates, period } = "") {
        const periods = {
            quarterly: [3, 6, 9, 12],
            semester: [6, 12],
            yearly: [12]
        };
        return dates.filter((date) => {
            const _date = new Date(date);
            return periods[period].includes(_date.getUTCMonth() + 1);
        });
    }

    /**
     * @public
     * Retorna um array de Date do dateStart até o dateEnd que batem com o period
     * (quarterly: março/junho/setembro/dezembro; semester: junho/dezembro; yearly: dezembro)
     * @param {Object} param0
     * @param {Date} param0.dateStart
     * @param {Date} param0.dateEnd
     * @param {"monthly"|"quarterly"|"semester"|"yearly"} param0.period
     * @returns {Array<Date>}
     */
    getDatesRangeByPeriod({ dateStart, dateEnd, period } = {}) {
        if (!dateStart || !dateEnd || !DateUtils.multipliers(period)) return [];

        const dates = [];
        let currentDate = new Date(dateStart);
        const endDate = new Date(dateEnd);

        while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate = DateUtils.addToDate(currentDate, 1, "months");
        }

        if (period === "monthly") return dates;

        return this.filterDatesByPeriod({ dates, period });
    }
}
